import React, { useState, useEffect, useRef } from 'react';
import InputMask from 'react-input-mask';
import { Radio, Select, Popup } from 'semantic-ui-react';
import { invoicingFrequencyOptions, isValidForm, updateDataToObj } from '..';
import { isPatternValid } from '../../../_utilities/validation';
import { IForm, IFormValidation} from '../types';

export const StepThree = (props) => {

    const { inputData, saveData, nextStep, validationData, saveValidationData } = props
    const [outputData, setOutputData] = useState<IForm>(inputData);
    const [valData, setValData] = useState<IFormValidation>(validationData);
    const [isValid, setIsValid] = useState<boolean>(false);

    const inputChange = (path, value, index = -1, extraKey = '') => {
        const tempData = updateDataToObj(outputData, path, value, index, extraKey);
        setOutputData({ ...tempData });
    }

    const inputBlur = (element, path, index = -1, extraKey = '') => {
        const tempVal = updateDataToObj(valData, path, isPatternValid(element.getAttribute('data-pattern'), element.value), index, extraKey);
        setValData({ ...tempVal });
    }

    const handleRadioChange = (e, { value }) => {
        let tempData: IForm = outputData;
        tempData.contractConditions.paymentDelay = value;
        setOutputData({ ...tempData });
    };

    const formRef = useRef(null);
    const formSubmit = (e) => {
        e.preventDefault();

        const oldCardsLimit = parseInt(outputData.contractConditions.contractCards.length);
        const newCardsLimit = parseInt(outputData.contractConditions.cardsNumber);

        if (oldCardsLimit != newCardsLimit)
            if (oldCardsLimit < newCardsLimit) {
                for (let i = 0; i < newCardsLimit - oldCardsLimit; i++) {
                    outputData.contractConditions.contractCards.push({
                        "cardNo": outputData.contractConditions.contractCards.length + 1,
                        "cardLimit": '',
                        "cardPhoneNumber": ''
                    })
                    valData.contractConditions.contractCards.push({
                        "cardNo": undefined,
                        "cardLimit": undefined,
                        "cardPhoneNumber": undefined
                    })
                }
            } else {
                for (let i = 0; i < oldCardsLimit - newCardsLimit; i++) {
                    outputData.contractConditions.contractCards.pop()
                    valData.contractConditions.contractCards.pop()
                }
            }

        saveData({ ...outputData });
        saveValidationData({ ...valData });
        nextStep(4);
    }

    useEffect(() => {
        setIsValid(isValidForm(formRef.current))
    }, [outputData, valData]);

    return <div className="m-form__step">

        <h2 className="m-form__header">Wnioskowane Warunki Umowy</h2>
        <form onSubmit={formSubmit} ref={formRef}>
            <div className="m-form__block">
                <div className={`m-form__field ${valData.contractConditions.totalLimit === false ? 'is--error' : ''}`}>
                    <label className="with-tooltip">
                        <span>Limit ogólny</span>
                        <Popup content='Odnawialny limit zobowiązań klienta, którego nie można przekroczyć. Każda splata zobowiązań (faktur) odnawia limit o kwotę rozliczonych dokumentów. W formularzu limit ograniczony jest do 100 tys. PLN. W wyjątkowych przypadkach, jest możliwość wynegocjowania większego limitu z Działem Skarbu.' trigger={<i className="icon-info"></i>} />
                    </label>
                    <div className="m-form__component ">
                        <InputMask
                            mask='999999'
                            placeholder=''
                            data-required
                            data-pattern="LIMIT"
                            name='contractConditions.totalLimit'
                            value={(outputData.contractConditions.totalLimit).toString()}
                            onChange={(e) => {
                                inputChange('contractConditions.totalLimit', e.target.value);
                            }}
                            onBlur={(e) => {
                                inputBlur(e.target, 'contractConditions.totalLimit');
                            }}
                        />
                    </div>
                    <div className="m-form__component-error">
                        {outputData.contractConditions.totalLimit == '' ? 'Proszę uzupełnić pole' : 'Prosze poprawić pole. Limit ogólny powinien zawierać się w przedziale od 1000PLN do 100000PLN.'}
                    </div>
                </div>
                <div className={`m-form__field ${valData.contractConditions.cardsNumber == false ? 'is--error' : ''}`}>
                    <label className="with-tooltip">
                        <span>Liczba kart</span>
                        <Popup content='Liczba kart, które będą przekazane użytkownikom za pomocą, których dokonywać będą zakupów w imieniu kontrahenta. Każda karta będzie miała swój własny limit w ramach limitu ogólnego.' trigger={<i className="icon-info"></i>} />
                    </label>
                    <div className="m-form__component ">
                        <InputMask
                            mask='999'
                            placeholder=''
                            data-required
                            data-pattern="CARDS"
                            name='contractConditions.cardsNumber'
                            value={(outputData.contractConditions.cardsNumber).toString()}
                            onChange={(e) => {
                                inputChange('contractConditions.cardsNumber', e.target.value);
                            }}
                            onBlur={(e) => {
                                inputBlur(e.target, 'contractConditions.cardsNumber');
                            }}
                        />
                    </div>
                    <div className="m-form__component-error">
                        {outputData.contractConditions.cardsNumber == '' ? 'Proszę uzupełnić pole' : 'Prosze poprawić pole. Maksymalnie 200 kart.'}
                    </div>
                </div>
                <div className={`m-form__field ${valData.contractConditions.invoicingFrequency == false ? 'is--error' : ''}`}>
                    <label>
                        <span>Częstotliwość wysyłania faktur</span>
                        <Popup content='Faktury są wysyłane okresowo i obejmują wszystkie transakcje klienta w całej Polsce wszystkimi jego kartami. System sprawdza czy doszło do transakcji Kartą z różną częstotliwością: Codziennie - faktury wysyłane są każdego dnia dla transakcji zrealizowanych poprzedniego dnia (lub weekend) lub 4/miesiąc: faktury wysyłane są cztery razy w miesiącu 1-szego, 9-tego, 16-tego, 23-ego lub następnego dnia roboczego.' trigger={<i className="icon-info"></i>} />

                    </label>
                    <Select
                        options={invoicingFrequencyOptions}
                        placeholder=''
                        name="contractConditions.invoicingFrequency"
                        value={outputData.contractConditions.invoicingFrequency}
                        onChange={(e, { name, value }) => {
                            inputChange(name, value);
                        }}
                    />
                </div>
            </div>
            <div className="m-form__block">
                <h3 className="m-form__subheader">
                    Termin odroczenia i prowizja
                </h3>
                <div className="m-form__field">
                    <Radio
                        label='15 dni - prowizja 0 pln'
                        value='15'
                        checked={outputData.contractConditions.paymentDelay == 15}
                        onChange={handleRadioChange}
                    />
                </div>
                <div className="m-form__field">
                    <Radio
                        label='30 dni - prowizja wg Tabeli prowizji'
                        value='30'
                        checked={outputData.contractConditions.paymentDelay == 30}
                        onChange={handleRadioChange}
                    />
                </div>
                <div className="m-form__field">
                    <Radio
                        label='60 dni - prowizja wg Tabeli prowizji'
                        value='60'
                        checked={outputData.contractConditions.paymentDelay == 60}
                        onChange={handleRadioChange}
                    />
                </div>
                <p className="m-form__text">
                    <small>prowizja wg <a href='/tabelaprowizji' target='_blank'><u>Tabeli prowizji</u></a> załączonej do Regulaminu</small>
                </p>
            </div>
            <div className="m-form__btns">
                <button type="submit" className="m-form__btn m-form__btn--next" disabled={!isValid}>Przejdź dalej</button>
                <button type="button" className="m-form__btn m-form__btn--back" onClick={() => { nextStep(2) }}>Powrót</button>
            </div>
        </form>

    </div>
}

